import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getEnviarPIN, getGuardarNumero, getNumeroRegistrado, NumeroRegistrado, PINResponse } from 'services/whatsappServices/whatsappService';
import { onServiceActive, onContentSelected, onModalOpen, onLoading, onPinSent, onPinReceived, onTelefonoWhatsapp } from 'store/servicioWhatsapp/servicioWhatsappSlice';
import { RootState } from 'store/store';

export const useServiceWhatsApp = () => {
    const dispatch = useDispatch();
    const {
        contentSelected,
        isModalOpen,
        loading,
        serviceActived,
        pinSent,
        pinRequeted,
        telefonoWhatsapp,
    } = useSelector((state: RootState) => state.servicioWhatsApp);
    const { user } = useSelector((state: RootState) => state.auth);

    const startGetStatusService = () => {
        dispatch(onLoading(true));
        // const openModalSession = localStorage.getItem('openModalSession');
        const idPersonaAutorizada = user.session?.cveUsuario;
        if (idPersonaAutorizada) {
            getNumeroRegistrado(String(idPersonaAutorizada))
                .then((response: NumeroRegistrado) => {
                    if (response.aceptaWhatsapp === 'S') {
                        dispatch(onServiceActive(true));
                        dispatch(onContentSelected('actualizarServicio'));
                        dispatch(onTelefonoWhatsapp(response.telefonoWhatsapp));
                    } else if (response.muestraMensajeWhatsapp === 'S') {
                        dispatch(onModalOpen(true));
                    } else {
                        dispatch(onServiceActive(false));
                        dispatch(onContentSelected('inicio'));
                        //dispatch(onModalOpen(openModalSession ? false : true));
                        localStorage.setItem('openModalSession', 'true');
                    }
                    dispatch(onLoading(false));
                })
                .catch((error: any) => {
                    console.log(error);
                    dispatch(onLoading(false));
                })
        } else {
            dispatch(onLoading(false));
        }
    }

    const starGetSentPin = (numTelefono: string) => {
        dispatch(onLoading(true));
        if (numTelefono) {
            getEnviarPIN({ numTelefono })
                .then((response: PINResponse) => {
                    if (response.status === 'success') {
                        dispatch(onPinSent(true));
                        dispatch(onPinReceived(response.pin));
                        dispatch(onContentSelected('confirmNumero'));
                        dispatch(onTelefonoWhatsapp(numTelefono));
                    }
                    dispatch(onLoading(false));
                })
                .catch((error: any) => {
                    console.log(error);
                    notify('Ocurrio un error al enviar el PIN', 'error');
                    dispatch(onLoading(false));
                })
        } else {
            dispatch(onLoading(false));
        }
    };

    const startGetGuardarNumero = (numTelefono: string, aceptaWhats: string = "S") => {
        dispatch(onLoading(true));
        if (numTelefono && user.session) {
            getGuardarNumero({ numTelefono, aceptaWhats, idPersonaAutorizada: String(user.session.cveUsuario) })
                .then((response: any) => {
                    if (aceptaWhats === 'N') {
                        notify('Servicio cancelado correctamente', 'success');
                        dispatch(onContentSelected('successInactive'));
                        dispatch(onServiceActive(false));
                        dispatch(onTelefonoWhatsapp(''));
                    } else if (aceptaWhats === 'S') {
                        notify('Servicio activado correctamente', 'success');
                        dispatch(onContentSelected('successActive'));
                        dispatch(onServiceActive(true));
                        dispatch(onTelefonoWhatsapp(numTelefono));
                    }
                    dispatch(onLoading(false));

                })
                .catch((error: any) => {
                    console.log(error);
                    notify('Ocurrio un error al enviar el PIN', 'error');
                    dispatch(onLoading(false));
                })
        } else {
            dispatch(onLoading(false));
        }
    };

    const closeModal = () => {
        dispatch(onModalOpen(false));
        dispatch(onLoading(false));
        setTimeout(() => {
            if (serviceActived) {
                dispatch(onContentSelected('actualizarServicio'));
            } else {
                dispatch(onContentSelected('inicio'));
                dispatch(onTelefonoWhatsapp(''));
            }
        }, 200);
        dispatch(onPinSent(false));
        dispatch(onPinReceived(null));
    }

    const notify = (msg: string, status: string = 'success') =>
        status === 'success' ? toast.success(msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: false,
        }) : toast.error(msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: false,
        });

    const setModalOpen = () => dispatch(onModalOpen(!isModalOpen));
    const setStatusServicio = () => dispatch(onServiceActive(!serviceActived));
    const setContentModal = (content: string) => dispatch(onContentSelected(content));
    const setTelefonWhatsapp = (telefono: string) => dispatch(onTelefonoWhatsapp(telefono));
    return {
        // props
        serviceActived,
        contentSelected,
        isModalOpen,
        loading,
        user,
        pinSent,
        pinRequeted,
        telefonoWhatsapp,
        //methods
        setModalOpen,
        setStatusServicio,
        setContentModal,
        setTelefonWhatsapp,
        startGetStatusService,
        starGetSentPin,
        startGetGuardarNumero,
        closeModal,
        notify
    }
}
